import { BillingManagementAccountType } from '@/redux/modules/billingManagement/billingManagement.types';

export type AccountNote = {
    accountId: number;
    accountType: BillingManagementAccountType;
    createdByUserId: number;
    createdByUsername: string;
    description: string;
    houseId: number;
    name: string;
    private: boolean;
};

export type AccountNoteSlice = {
    wasSaveSuccessful: boolean | undefined;
};

export const defaultAccountNoteSlice: AccountNoteSlice = {
    wasSaveSuccessful: undefined,
};
